import { Button, Box, Typography, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomMarkdown from "./customMarkdown";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function ContextShow({ contextData }) {
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    // context data arrives from parent; no side effects required here
  }, [contextData]);

  const handleClickDoc = async (e, source) => {
    e.stopPropagation();
    try {
      setFetching(true);
      window.open(`/doc-view/${source.docs_id || "1"}`, "_blank");
      setFetching(false);
    } catch (e) {
      console.error("Error opening document:", e);
      setFetching(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f8f9fa", p: 2, borderRadius: "12px" }}>
      {contextData?.sources && contextData.sources.length > 0 ? (
        contextData.sources.map((source, index) => (
          <Box key={index} sx={{ mb: 3, "&:last-child": { mb: 0 } }}>
            <Button
              variant="contained"
              size="small"
              onClick={(e) => handleClickDoc(e, source)}
              disabled={fetching}
              sx={{
                textTransform: "none",
                borderRadius: "12px",
                px: 2,
                py: 1,
                fontWeight: 600,
                backgroundColor: "rgba(24, 116, 210, 0.9)",
                boxShadow: "0 4px 12px rgba(24, 116, 210, 0.25)",
                border: "1px solid rgba(24, 116, 210, 0.3)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor: "rgba(24, 116, 210, 1)",
                  boxShadow: "0 6px 20px rgba(24, 116, 210, 0.35)",
                  transform: "translateY(-1px)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "rgba(24, 116, 210, 0.3)",
                  color: "rgba(255, 255, 255, 0.6)",
                  transform: "none",
                },
              }}
              endIcon={
                <Tooltip
                  title={source?.pdf || String(source?.docs_id || "")}
                  arrow
                >
                  <InfoOutlinedIcon sx={{ fontSize: 18, color: "#e3f2fd" }} />
                </Tooltip>
              }
            >
              Show Document
            </Button>
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "1px solid rgba(24, 116, 210, 0.12)",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
              }}
            >
              <CustomMarkdown
                markdown={source?.context || ""}
                contextArray={[]}
                handleContextModalOpen={() => {}}
                showInlineContext={false}
              />
            </Box>
          </Box>
        ))
      ) : (
        <Box
          sx={{
            p: 3,
            textAlign: "center",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            border: "1px solid rgba(24, 116, 210, 0.12)",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "#666666", fontStyle: "italic" }}
          >
            No context available.
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default ContextShow;
